<template>
    <div class="">
        <div class="container box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item"></div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <button class="button is-light is-link">Last Day</button>
                    </div>
                    <div class="level-item">
                        <button class="button is-light is-success">
                            <font-awesome-icon icon="search"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="timeline-content">
            <div class="main-title-timeline">
                <h3 class="">6 Entries</h3>
            </div>
            <ul class="timeline">
                <li class="event box" data-date="23  Jully 2020 11:43">
                    <h3 class="event-title">Additional Document</h3>
                    <p class=" event-content">Document added(FileJeppesen)</p>
                </li>
                <li class="event box" data-date="12  Jully 2020 12:43">
                    <h3 class="event-title">Netline Flights</h3>
                    <p class="event-content">Update flight by Emre ÖZKAN </p>
                </li>
                <li class="event box" data-date="23  April 2020 12:43" style="background-color: #f14668">
                    <h3 class="event-title">Netline Flights</h3>
                    <p class="event-content">Update flight by Emre ÖZKAN </p>
                </li>
                <li class="event box" data-date="20  April 2020 12:43">
                    <h3 class="event-title">Netline Flights</h3>
                    <p class="event-content">Update flight by Hakan KAZAK </p>
                </li>
                <li class="event box" data-date="10  April 2020 12:43">
                    <h3 class="event-title">Netline Flights</h3>
                    <p class="event-content">Update flight by Emre ÖZKAN </p>
                </li>
                <li class="event box" data-date="12 March 2020 12:43">
                    <h3 class="event-title">Netline Flights</h3>
                    <p class="event-content">Update flight by Emre ÖZKAN </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Timeline"
    }
</script>

<style scoped lang="scss">
    /* Variables */

    $background: #252827;
    $color-primary: rgba(28, 166, 248, 0.66);
    $color-light: white;
    $color-dim: #6c6d6d;
    $spacing: 50px;
    $radius: 4px;
    $date: 120px;
    $dotborder: 4px;
    $dot: 11px;
    $line: 4px;
    $font-title: 'Saira', sans-serif;
    $font-text: 'Chivo', sans-serif;

    /* Base */
    .event-content {

        padding: 20px;
        font-size: 14px;
    }

    .event-title {
        padding: 20px;
        font-size: 20px;
        font-weight: bolder;
        font-style: oblique;
    }

    body {
        background: $background;
        font-size: 16px;
    }

    p {
        font-weight: 300;
    }

    a {
        color: $color-dim;
        text-decoration: none;
        text-transform: uppercase;
        display: block;
        letter-spacing: .3em;
        font-size: .6em;
        font-weight: 400;
        background: #252727;
        padding: .3rem 1rem;
        margin: 1.9rem 0 0 0;
        float: right;
    }

    a:hover {
        color: $color-light;
        background: $color-primary;
        border-bottom: .35em solid black;
    }

    strong {
        font-weight: 600;
    }

    h1 {
        font-family: $font-title;
        letter-spacing: 1.5px;
        color: $color-light;
        font-weight: 400;
        font-size: 2.4em;
    }

    #timeline-content {
        margin-top: $spacing;
        text-align: center;
    }

    /* Timeline */
    .main-title-timeline {
        border-top-right-radius: 40px;
        border-bottom-right-radius: 40px;
        border: 1px solid;
        width: 200px;
        margin-left: 780px;
        margin-bottom: -81px;
        border-left-width: thick;
        padding: 2px;
        background-color: darkgrey;
    }
    .main-title-timeline span{
        position:absolute;
        top:-1px;
        left:calc(100% - 10px);
        z-index:-1;
        white-space:nowrap;
        display:inline-block;
        background-color:#111;
        padding:4px 10px 4px 20px;
        border-top-right-radius:40px;
        border-bottom-right-radius:40px;
        border:1px solid black;
        box-sizing:border-box;
    }

    .timeline {
        border-left: $line solid $color-primary;
        border-bottom-right-radius: $radius;
        border-top-right-radius: $radius;
        background: fade($color-light, 3%);
        color: fade(white, 80%);
        font-family: $font-text;
        margin: $spacing auto;
        letter-spacing: 0.5px;
        position: relative;
        line-height: 1.4em;
        font-size: 1.03em;
        padding: $spacing;
        list-style: none;
        text-align: left;
        font-weight: 100;
        max-width: 30%;

        h1 {
            font-family: $font-title;
            letter-spacing: 1.5px;
            font-weight: 100;
            font-size: 1.4em;
        }

        h2, h3 {
            font-family: $font-title;
            letter-spacing: 1.5px;
            font-weight: 400;
            font-size: 1.4em;
        }

        .event {
            border-bottom: 1px dashed fade($color-light, 10%);
            padding-bottom: ($spacing * 0.5);
            margin-bottom: $spacing;
            position: relative;
            background-color: rgba(29, 235, 80, 0.45);

            &:last-of-type {
                padding-bottom: 0;
                margin-bottom: 0;
                border: none;
            }

            &:before, &:after {
                position: absolute;
                display: block;
                top: 0;
            }

            &:before {
                left: ((($date * 0.6) + $spacing + $line + $dot + ($dotborder * 2)) * 1.5) * -1;
                color: fade($color-light, 40%);
                content: attr(data-date);
                text-align: right;
                font-weight: 100;
                font-size: 0.9em;
                min-width: $date;
                font-family: $font-title;
            }

            &:after {
                box-shadow: 0 0 0 $dotborder fade($color-primary, 100%);
                left: ($spacing + $line + ($dot * 0.35)) * -1;
                background: lighten($background, 5%);
                border-radius: 50%;
                height: $dot;
                width: $dot;
                content: "";
                top: 5px;
            }
        }
    }
</style>
